module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-01-image-01.903efbc6.png";